import { Button } from '@arkestro/arkestro-design-system';
import useTranslation from 'next-translate/useTranslation';

import styles from './rename-columns-drawer.module.scss';

interface RenameColumnsDrawerFooterProps {
  canSave: boolean;
  isPending: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export const RenameColumnsDrawerFooter = ({
  canSave,
  isPending,
  onCancel,
  onSave,
}: RenameColumnsDrawerFooterProps) => {
  const { t } = useTranslation('common');

  return (
    <div className={styles.footer}>
      <Button dataTestId='column-labels-cancel' disabled={isPending} ghost onClick={onCancel} type='primary'>
        {t('general.cancel')}
      </Button>
      <Button
        dataTestId='column-labels-save'
        disabled={!canSave || isPending}
        loading={isPending}
        onClick={onSave}
        type='primary'
      >
        {t('general.save')}
      </Button>
    </div>
  );
};
